var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 120,
    viewBox: "0 0 512 512",
    width: 120,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.5 38.5h497v435h-497z",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.5 38.5h40v435h-40z",
    fill: "#f7d200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 38.5h497v57.167h-497z",
    fill: "#7b7b7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.5 38.5h40v57.167h-40z",
    fill: "#6b6b73"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 242.776,
    fill: "#ff7de9",
    r: 57.69
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41.922 74.583c9.992 0 10.008-15 0-15-9.992 0-10.008 15 0 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.755 74.583c9.992 0 10.008-15 0-15-9.992 0-10.008 15 0 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.589 74.583c9.992 0 10.008-15 0-15-9.992 0-10.009 15 0 15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m504.5 31h-320.508c-9.697 0-9.697 15 0 15h313.008v42.167h-482v-42.167h129.136c9.697 0 9.697-15 0-15h-136.636c-4.143 0-7.5 3.358-7.5 7.5v435c0 4.142 3.357 7.5 7.5 7.5h497c4.143 0 7.5-3.358 7.5-7.5v-435c0-4.142-3.357-7.5-7.5-7.5zm-489.5 435v-362.833h482v362.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.35 273.231h48.487c-.063 8.932-.132 17.639-.2 25.507-.08 9.414 15.113 10.015 15.2.129.025-2.994-.091-12.954 0-25.636h6.878c9.697 0 9.697-15 0-15h-6.778c.173-27.9.293-60.279-.046-64.337-1.189-14.288-16.676-19.356-25.951-7.974-6.391 7.841-40.311 69.216-44.157 76.188-2.044 6.207.145 9.914 6.567 11.123zm48.643-77.072c.205 6.209.119 33.522-.057 62.072h-35.856c13.572-24.391 31.213-55.477 35.913-62.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.285 273.231h48.488c-.063 8.932.068 17.639 0 25.507-.08 9.414 14.713 10.015 14.8.129.025-2.994.109-12.954.2-25.636h6.877c9.697 0 9.697-15 0-15h-6.777c.173-27.9.293-60.279-.046-64.337-1.189-14.29-16.675-19.354-25.951-7.974-6.391 7.841-40.311 69.216-44.158 76.188-2.044 6.207.145 9.914 6.567 11.123zm48.645-77.072c.205 6.209.119 33.522-.057 62.072h-35.857c13.571-24.389 31.212-55.474 35.914-62.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 307.965c9.018 0 17.769-1.82 26.011-5.411 8.891-3.873 2.899-17.626-5.99-13.752-32.48 14.601-70.621-10.389-70.21-46.027 0-27.674 22.514-50.189 50.189-50.189 36.763-.45 61.769 40.015 44.882 72.649-4.348 8.668 9.06 15.391 13.408 6.724 21.939-42.394-10.532-94.958-58.291-94.372-86.478 3.578-86.46 126.809.001 130.378z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.603 222.174c-2.93-2.929-7.678-2.929-10.607 0l-9.996 9.995-9.995-9.995c-6.858-6.856-17.465 3.749-10.607 10.606l9.996 9.996-9.996 9.996c-6.857 6.857 3.749 17.462 10.607 10.606l9.995-9.995 9.995 9.995c6.858 6.856 17.465-3.749 10.607-10.606l-9.996-9.996 9.996-9.996c2.929-2.928 2.929-7.677.001-10.606z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.327 344.369c-9.697 0-9.697 15 0 15h193.346c9.697 0 9.697-15 0-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.782 380.63h-337.564c-9.697 0-9.697 15 0 15h337.564c9.698 0 9.698-15 0-15z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.667cbe29fc90eed1d174247819edbe16.svg";
export { ForwardRef as ReactComponent };